import { render, staticRenderFns } from "./RetailerList.vue?vue&type=template&id=4d2c6ebe&scoped=true&"
import script from "./RetailerList.vue?vue&type=script&lang=js&"
export * from "./RetailerList.vue?vue&type=script&lang=js&"
import style0 from "./RetailerList.vue?vue&type=style&index=0&id=4d2c6ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c6ebe",
  null
  
)

export default component.exports